module.exports = __webpack_public_path__ + "img/past_month_balance.b1acf080.svg";